import {
  UPDATE_TRAVELLER_DETAILS,
  RESET_TRAVELLER_DETAILS,
  TravellerDetailsTypes,
  TravellerDetailsActionTypes,
} from './types';
import {titlesMap} from '@stencil/hotels-utils/src/common-utils';

const initialState: TravellerDetailsTypes = {
  formData: {
    nameDetails: [
      {
        nameTitle: titlesMap[0].value,
        firstName: '',
        middleName: '',
        lastName: '',
      },
    ],
    email: '',
    phoneNumber: '',
    businessProfile: false,
    gstNumber: '',
    companyName: '',
    businessEmail: '',
    countryCode: '91',
    travellersPan: '',
    companyAddress: '',
    companyPhone: '',
    companyEmail: '',
    specialReq: '',
    selectedCheckinTime: '',
  },
};

export default function travellerDetailsReducer(
  state = initialState,
  action: TravellerDetailsActionTypes,
) {
  switch (action.type) {
    case UPDATE_TRAVELLER_DETAILS:
      return {
        ...state,
        formData: {...state.formData, ...action.actionData},
      };
    case RESET_TRAVELLER_DETAILS:
      return initialState;
    default:
      return state;
  }
}
